import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import {
  BusinessEmailLimit,
  UpdateBusinessEmailLimitRequest,
  UserEmailChannelType,
} from '../models/business-email-limit.model';

/**
 * API de límites de envío de email de la empresa actual (rol Admin o superior).
 * El businessId se resuelve en el backend a partir del JWT — NO se envía.
 */
@Injectable({ providedIn: 'root' })
export class BusinessEmailLimitsApiService {
  private readonly http = inject(HttpClient);
  private readonly base = `${environment.apiUrl}api/email-channel-policies`;

  /** Lista los límites efectivos de los 4 canales de usuario (array plano). */
  list(): Observable<BusinessEmailLimit[]> {
    return this.http.get<BusinessEmailLimit[]>(this.base);
  }

  /** Crea/actualiza el override de la empresa para un canal. */
  upsert(
    channelType: UserEmailChannelType,
    req: UpdateBusinessEmailLimitRequest
  ): Observable<BusinessEmailLimit> {
    return this.http.put<BusinessEmailLimit>(`${this.base}/${channelType}`, req);
  }

  /** Elimina el override de la empresa para un canal: revierte al global. */
  resetToGlobal(channelType: UserEmailChannelType): Observable<void> {
    return this.http.delete<void>(`${this.base}/${channelType}`);
  }
}
